import { useQuery, gql, type QueryHookOptions } from "@apollo/client";

const LISTING_AGENTS_QUERY = gql`
  query ListingAgents {
    listingAgents {
      id
    }
  }
`;

interface ListingAgent {
  id: string;
}

interface ListingAgentsData {
  listingAgents: ListingAgent[];
}

const useListingAgentsQuery = (options?: QueryHookOptions<ListingAgentsData>) => {
  return useQuery<ListingAgentsData>(LISTING_AGENTS_QUERY, options);
};

export { useListingAgentsQuery };
export type { ListingAgentsData };
